import { historyUpdateMarker, patchHistory } from './chunk-MPZ6OMIB.js';
import { renderQueryString } from './chunk-DASHEO2X.js';
import mitt from 'mitt';
import { useCallback, startTransition, useState, useEffect } from 'react';

function createReactRouterBasedAdapter(adapter, useNavigate, useSearchParams) {
  const emitter = mitt();
  function useNuqsReactRouterBasedAdapter() {
    const navigate = useNavigate();
    const searchParams = useOptimisticSearchParams();
    const updateUrl = useCallback(
      (search, options) => {
        startTransition(() => {
          emitter.emit("update", search);
        });
        const url = new URL(location.href);
        url.search = renderQueryString(search);
        const updateMethod = options.history === "push" ? history.pushState : history.replaceState;
        updateMethod.call(
          history,
          history.state,
          // Maintain the history state
          historyUpdateMarker,
          url
        );
        if (options.shallow === false) {
          navigate(
            {
              // Somehow passing the full URL object here strips the search params
              // when accessing the request.url in loaders.
              hash: url.hash,
              search: url.search
            },
            {
              replace: true,
              preventScrollReset: true,
              state: history.state?.usr
            }
          );
        }
        if (options.scroll) {
          window.scrollTo(0, 0);
        }
      },
      [navigate]
    );
    return {
      searchParams,
      updateUrl
    };
  }
  function useOptimisticSearchParams() {
    const [serverSearchParams] = useSearchParams();
    const [searchParams, setSearchParams] = useState(serverSearchParams);
    useEffect(() => {
      function onPopState() {
        setSearchParams(new URLSearchParams(location.search));
      }
      function onEmitterUpdate(search) {
        setSearchParams(search);
      }
      emitter.on("update", onEmitterUpdate);
      window.addEventListener("popstate", onPopState);
      return () => {
        emitter.off("update", onEmitterUpdate);
        window.removeEventListener("popstate", onPopState);
      };
    }, []);
    return searchParams;
  }
  function enableHistorySync() {
    patchHistory(emitter, adapter);
  }
  return {
    useNuqsReactRouterBasedAdapter,
    useOptimisticSearchParams,
    enableHistorySync
  };
}

export { createReactRouterBasedAdapter };
